import { Flex, Tooltip } from "antd";
import { Dispatch, SetStateAction } from "react";
import {
  IconHandLoveYou,
  IconMoodPuzzled,
  IconLock,
} from "@tabler/icons-react";

const VenuConfirmationEvent = ({
  show,
  setShow,
  scheduleVenueLocked = false,
  isLocked = false,
}: {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  scheduleVenueLocked?: boolean;
  isLocked?: boolean;
}) => {
  const fullyLocked = isLocked || scheduleVenueLocked;
  const tbdDisabled = fullyLocked;

  const baseCardStyle: React.CSSProperties = {
    borderRadius: 12,
    padding: "14px 18px",
    cursor: "pointer",
    userSelect: "none",
    transition: "all 0.15s ease",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    minWidth: 130,
    maxWidth: 150,
    border: "1.5px solid transparent",
  };

  const selectedStyle: React.CSSProperties = {
    border: "1.5px solid #021526",
    background: "#fff",
    boxShadow: "0 2px 8px rgba(2,21,38,0.10)",
  };

  const defaultStyle: React.CSSProperties = {
    border: "1.5px solid #e5e7eb",
    background: "#fafafa",
  };

  const disabledStyle: React.CSSProperties = {
    opacity: 0.5,
    cursor: "not-allowed",
  };

  return (
    <>
      <Flex gap={16} className="!mb-[16px]" align="flex-start">
        {/* I have decided the venue */}
        <Tooltip
          title={
            fullyLocked
              ? "Venue is locked after the first ticket is booked"
              : undefined
          }
        >
          <div
            role="button"
            tabIndex={fullyLocked ? -1 : 0}
            onClick={() => !fullyLocked && setShow(false)}
            onKeyDown={(e) =>
              e.key === "Enter" && !fullyLocked && setShow(false)
            }
            style={{
              ...baseCardStyle,
              ...(!show ? selectedStyle : defaultStyle),
              ...(fullyLocked ? disabledStyle : {}),
            }}
          >
            <div
              className="w-[45px] h-[45px] bg-[#F3F6F9] rounded-[8px] flex items-center justify-center"
              style={{ position: "relative" }}
            >
              <IconHandLoveYou size={24} />
              {fullyLocked && (
                <div
                  style={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    background: "#6b7280",
                    borderRadius: "50%",
                    width: 16,
                    height: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IconLock size={10} color="#fff" />
                </div>
              )}
            </div>
            <strong
              style={{
                fontSize: 13,
                textAlign: "center",
                color: !show ? "#021526" : "#374151",
                lineHeight: 1.3,
              }}
            >
              I have decided the venue
            </strong>
          </div>
        </Tooltip>

        {/* Will think of a venue later */}
        <Tooltip
          title={
            fullyLocked
              ? "Venue is locked after the first ticket is booked"
              : undefined
          }
        >
          <div
            role="button"
            tabIndex={tbdDisabled ? -1 : 0}
            onClick={() => !tbdDisabled && setShow(true)}
            onKeyDown={(e) =>
              e.key === "Enter" && !tbdDisabled && setShow(true)
            }
            style={{
              ...baseCardStyle,
              ...(show ? selectedStyle : defaultStyle),
              ...(tbdDisabled ? disabledStyle : {}),
            }}
          >
            <div
              className="w-[45px] h-[45px] bg-[#F3F6F9] rounded-[8px] flex items-center justify-center"
              style={{ position: "relative" }}
            >
              <IconMoodPuzzled size={24} />
              {fullyLocked && (
                <div
                  style={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    background: "#6b7280",
                    borderRadius: "50%",
                    width: 16,
                    height: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IconLock size={10} color="#fff" />
                </div>
              )}
            </div>
            <strong
              style={{
                fontSize: 13,
                textAlign: "center",
                color: show ? "#021526" : "#374151",
                lineHeight: 1.3,
              }}
            >
              Will think of a venue later
            </strong>
          </div>
        </Tooltip>
      </Flex>

      {/* Locked banner */}
      {fullyLocked && (
        <div
          style={{
            marginBottom: 16,
            padding: "8px 12px",
            background: "#f9fafb",
            border: "1px solid #d1d5db",
            borderRadius: 8,
            fontSize: 12,
            color: "#6b7280",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <IconLock size={13} />
          Venue details are locked. Changes are not allowed after the first
          ticket has been booked or while the event is under admin review.
        </div>
      )}
    </>
  );
};

export default VenuConfirmationEvent;
